<template>
  <div
    :class="[
      'flex items-center gap-3 p-4 text-sm text-gray-900 rounded-lg',
      { 'bg-blue-50 border-blue-100 border': type === 'info' },
      { 'bg-orange-50 border-orange-100 border': type === 'warning' },
      { 'bg-red-50 border-red-100 border': type === 'error' }
    ]"
    role="alert"
  >
    <InfoIcon v-if="type === 'info'" class="h-4 text-blue-900" />
    <WarningIcon v-if="type === 'warning'" class="h-6 text-yellow-300" />
    <WarningIcon v-if="type === 'error'" class="h-6 text-red-700" />
    <div>
      <slot>{{ text }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import InfoIcon from "@/images/info.svg?component";
import WarningIcon from "@/images/Warning.svg?component";

withDefaults(
  defineProps<{ text?: string; type?: "info" | "warning" | "error" }>(),
  {
    type: "info",
    text: ""
  }
);
</script>

<style scoped></style>
